// extracted by mini-css-extract-plugin
module.exports = {"asset-details-metadata":"asset-details-metadata__xuQv8","asset-details-metadata__bullet":"asset-details-metadata__bullet__vEmLn"};